/* eslint-disable react/prop-types */
// Small clear-line drawings: one even line, flat fills, no shading.
// They sit on paper fills, so the line stays ink-black by day and night.
const ink = { strokeWidth: 3, strokeLinejoin: 'round', strokeLinecap: 'round' }

export const Cloud = ({ className }) => (
  <svg aria-hidden='true' viewBox='0 0 160 70' className={className}>
    <path
      d='M20 60h120a16 16 0 0 0-6-31 22 22 0 0 0-38-14 26 26 0 0 0-46 9 18 18 0 0 0-30 18 9 9 0 0 0 0 18Z'
      className='fill-paper stroke-coal'
      {...ink}
    />
  </svg>
)

// Day one: the brief arrives as a sketched sheet and a pencil.
export const Brief = () => (
  <svg aria-hidden='true' viewBox='0 0 220 150' className='h-full w-full'>
    <path d='M58 14h84l20 20v104H58Z' className='fill-paper stroke-coal' {...ink} />
    <path d='M142 14v20h20' className='fill-none stroke-coal' {...ink} />
    <path d='M72 42h56v26H72Z' className='fill-sky stroke-coal' {...ink} />
    <path d='M72 80h70M72 94h52M72 108h62M72 122h34' className='fill-none stroke-coal' {...ink} />
    <path d='m170 40 26 10-44 92-14 6 0-14 32-94Z' className='fill-caption stroke-coal' {...ink} />
    <path d='m138 134 14 8' className='fill-none stroke-coal' {...ink} />
  </svg>
)

// Every day: a calendar page filling with ticks.
export const Progress = () => (
  <svg aria-hidden='true' viewBox='0 0 220 150' className='h-full w-full'>
    <path d='M40 24h140v116H40Z' className='fill-paper stroke-coal' {...ink} />
    <path d='M40 24h140v26H40Z' className='fill-signal stroke-coal' {...ink} />
    <path d='M72 14v20M148 14v20' className='fill-none stroke-coal' {...ink} />
    <path
      d='M56 74l6 6 12-12M96 74l6 6 12-12M136 74l6 6 12-12M56 108l6 6 12-12M96 108l6 6 12-12'
      className='fill-none stroke-coal'
      {...ink}
    />
    <path d='M134 104h24v18h-24Z' className='fill-caption stroke-coal' {...ink} />
  </svg>
)

// Launch: the finished app in a browser window, cursor on the last hover state.
export const Launch = () => (
  <svg aria-hidden='true' viewBox='0 0 220 150' className='h-full w-full'>
    <path d='M22 18h176v118H22Z' className='fill-paper stroke-coal' {...ink} />
    <path d='M22 18h176v20H22Z' className='fill-sand stroke-coal' {...ink} />
    <circle cx='36' cy='28' r='4' className='fill-signal stroke-coal' {...ink} />
    <path d='M38 54h80v12H38ZM38 76h60M38 88h70' className='fill-none stroke-coal' {...ink} />
    <path d='M38 104h58v20H38Z' className='fill-sky stroke-coal' {...ink} />
    <path d='M134 54h48v70h-48Z' className='fill-caption stroke-coal' {...ink} />
    <path d='m84 110 0 26 7-7 6 13 6-3-6-13 10 0Z' className='fill-paper stroke-coal' {...ink} />
  </svg>
)
